export interface SharedOrgMetricsRequestDto {
  departmentId?: string;
  userIds?: string[];
}
